import { useCallback, useMemo } from 'react';

import { useProviderConfigController_getProviderSchemas } from '@/services/hooks';

import { type ProviderConfigError, parsedErrorOrNull } from './errors';
import { mapSchemas } from './mappers';
import type { ProviderSchema } from './types';

export interface UseProviderSchemasResult {
    schemas: ProviderSchema[];
    isLoading: boolean;
    isFetching: boolean;
    error: ProviderConfigError | null;
    /** Asks again, for a page whose first load failed. */
    refetch: () => void;
}

/** Schemas change only with a deploy, so one fetch per page load is enough. */
export function useProviderSchemas(): UseProviderSchemasResult {
    const query = useProviderConfigController_getProviderSchemas({
        staleTime: Number.POSITIVE_INFINITY,
    });
    const dtos = query.data?.data;
    const schemas = useMemo(() => (dtos ? mapSchemas(dtos) : []), [dtos]);
    const error = useMemo(() => parsedErrorOrNull(query.error), [query.error]);
    const { refetch: refetchQuery } = query;
    const refetch = useCallback(() => {
        void refetchQuery();
    }, [refetchQuery]);
    return { schemas, isLoading: query.isPending, isFetching: query.isFetching, error, refetch };
}
